import React from 'react';
import { FormControl, TextareaAutosize, Grid } from '@material-ui/core';

import { connect, useDispatch } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import useStyles from '../styles/styles';

const formName = 'battery-form';

type PeTextAreaProps = {
  readonly input?: any,
  readonly id?: string,
  readonly label: string,
  readonly required?: boolean,
  readonly meta?: { 
    touched: any, 
    error: any 
  },
  readonly formValues: any,
}

const PeTextArea: React.FC<PeTextAreaProps> = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const text = typeof props.formValues !== 'undefined' ? props.formValues[props.input.name] : "";

  const handleChange = (event: any) => {
    // set current value to field
    dispatch(change(formName, props.input.name, event.target.value));
  }

  return <Grid id={props.id} container className={classes.control}>
    <FormControl variant="outlined" fullWidth>
      <h3 className={classes.label}>SMS Template:</h3>
      <TextareaAutosize
          id={props.input.id}
          name={props.input.name}
          onChange={handleChange}
          minRows={9}
          style={{
              fontSize: '14px',
              fontWeight: 400,
              padding: '10px',
          }}
          placeholder={'Type some thing...'}
          value={text}
      />
    </FormControl>
  </Grid>
}

export default connect(state => ({formValues: getFormValues(formName)(state)}))(PeTextArea);